import { connect } from 'react-redux';
import { assign as _assign } from 'lodash';

import {
  ChangePasswordModel,
  CreateFormProps,
  GlobalState,
  formatMessage
} from 'src/api';

import {
  createForm, 
  FormValues, 
} from 'src/api/models/Form/Form';

import {
  ChangePasswordFormValues
} from 'src/api/models/ChangePassword/change-password.class';

import { 
  requestAPIActions, 
  RequestApiHttpPayload,
  removeAccessTokenFromCookie,
  clearAuthentification,
} from 'loopback-react-request';

import './ChangePasswordForm.scss';

import MESSAGES from './ChangePasswordForm.messages';
import { appSettings } from 'src/config';

const changePasswordFormProperty = createForm<ChangePasswordModel, CreateFormProps<ChangePasswordModel>>({
  afterSubmitSuccess: (dispatch, state) => {
    removeAccessTokenFromCookie(appSettings.cookieName);
    dispatch(clearAuthentification());
  },
  className: 'partial-login-form my-0 mx-auto',
  dispatchData: (dispatch, values) => dispatch(
    requestAPIActions.load<RequestApiHttpPayload>('changePassword', {
      url: '/Users/change-password',
      options: {
        method: 'POST',
        data: values,
      },
    }
  )),
  formFields: ChangePasswordFormValues(),
  preSubmit: (values: FormValues<ChangePasswordModel>, state: GlobalState | undefined) => {
    let userData = state && state.userData && state.userData.result;
    if (userData) {
      _assign (values, {id: userData.userId});
    }
    delete values.password;
    
    return values;
  },
  redirectTo: '/change-password/succeeded',
  shouldRedirect: true,
  stateKeys: 'changePassword',
  submitButton: {
    text: formatMessage({...MESSAGES.changePasswordButton}),
    className: 'register-button mt-3 mb-5 w-100'
  }
})();

export const ChangePasswordForm = connect((state: GlobalState) => ({state}))(changePasswordFormProperty);